module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tools-tab tools-tab-user tools-mobile",
    class: [_vm.$onduro.hasModule('availability') ? 'has-availability' : '']
  }, [(!_vm.loading) ? _c('ul', {
    staticClass: "list"
  }, [_vm._l((_vm.activeDuties), function(duty) {
    return (_vm.filterUsersByDuty(duty).length) ? [(_vm.filterUsersByDuty(duty).length) ? _c('li', {
      staticClass: "box-duty",
      style: ('background:' + duty.color)
    }, [_c('span', [_vm._v(_vm._s(duty.name))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filterUsersByDuty(duty)), function(user) {
      return _c('li', {
        on: {
          "click": function($event) {
            return _vm.select(user, duty)
          }
        }
      }, [(_vm.$onduro.hasModule('availability')) ? _c('span', {
        class: _vm.getAvailabilityClasses(user)
      }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(user.name))]), _vm._v(" "), (_vm.multiple) ? _c('icon', {
        attrs: {
          "name": "add"
        }
      }) : _c('icon', {
        attrs: {
          "name": "check"
        }
      })], 1)
    })] : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.users), function(user) {
    return (!_vm.activeDuties) ? _c('li', {
      on: {
        "click": function($event) {
          return _vm.select(user)
        }
      }
    }, [(_vm.$onduro.hasModule('availability')) ? _c('span', {
      class: _vm.getAvailabilityClasses(user)
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(user.name))]), _vm._v(" "), (_vm.multiple) ? _c('icon', {
      attrs: {
        "name": "add"
      }
    }) : _c('icon', {
      attrs: {
        "name": "check"
      }
    })], 1) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.users.length) ? _c('div', {
    staticClass: "empty"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('page.roster.tools.empty_users')) + "\n    ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1810cfea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/tools/NewUser.vue
// module id = 614
// module chunks = 234